module.exports = __webpack_public_path__ + "static/media/review.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/review.svg
// module id = 491
// module chunks = 0